export const NotificationsMutations = {
  setRecentUnreadNotifications: (state, payload) => {
    state.recentUnreadNotifications = payload
  },

  setNotificationsList: (state, payload) => {
    state.notificationsList = payload
  },

  updateNotificationEntry: (state, payload) => {
    const unreadIdx = state.recentUnreadNotifications.findIndex(n => n.id === payload.id)
    if (unreadIdx >= 0) state.recentUnreadNotifications[unreadIdx] = payload

    const listIdx = state.notificationsList.findIndex(n => n.id === payload.id)
    if (listIdx >= 0) state.notificationsList[listIdx] = payload
  },

  setTotalNotificationsCount (state, value) {
    state.totalNotificationsCount = value
  },

  setUnreadNotificationsCount (state, value) {
    state.unreadNotificationsCount = value
  },

  setNotificationAsRead (state, notificationId) {
    const unreadIdx = state.recentUnreadNotifications.findIndex(notification => notification.id === notificationId)
    if (unreadIdx >= 0) state.recentUnreadNotifications.splice(unreadIdx, 1)

    const listIdx = state.notificationsList.findIndex(n => n.id === notificationId)
    if (listIdx >= 0) state.notificationsList[listIdx].read = true
  },

  setAllNotificationsAsRead (state) {
    state.recentUnreadNotifications.splice(0)
    state.notificationsList.forEach(notification => { notification.read = true })
  },
}
